import React from 'react';

import ButtonLink from '../../ButtonLink';

import getLinkTarget, { TARGET_TYPE } from '../getLinkTarget';

import { button, layout, titlePrefix } from './styles.module.css';

const LoginPromptBanner = () => (
  <div className={layout}>
    <div>
      <span className={titlePrefix}>Looking for something? </span>
      <span>Find your next challenge.</span>
    </div>
    <ButtonLink to={getLinkTarget(TARGET_TYPE.BANNER)} primary className={button}>
      Join the club
    </ButtonLink>
  </div>
);

export default LoginPromptBanner;



// WEBPACK FOOTER //
// ./app/src/components/LoginPrompt/Banner/index.jsx